/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 託送契約月別託送供給量情報
 */
export interface Szoa304aReqConsignmentcontractMonthlytakusosupplyInfoDto {
    /**
     * 対象月
     */
    targetMonth?: string;
    /**
     * 供給量
     */
    supplyVal?: string;
}

